const channels = require.context('.', true, /\.js$/)
channels.keys().forEach(channels)